var React = require('react');

function InformationIconQuestion (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"opacity":"0.5","cx":"14","cy":"14","r":"14","fill":"#15BE53","key":0}),React.createElement("circle",{"cx":"14","cy":"14","r":"10","fill":"#15BE53","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18 15C18 14.4477 17.5523 14 17 14V13C17 11.3431 15.6569 10 14 10C12.3431 10 11 11.3431 11 13V14C10.4477 14 10 14.4477 10 15V17C10 17.5523 10.4477 18 11 18H17C17.5523 18 18 17.5523 18 17V15ZM13 13C13 12.4477 13.4477 12 14 12C14.5523 12 15 12.4477 15 13V14H13V13Z","fill":"white","key":2})]);
}

InformationIconQuestion.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = InformationIconQuestion;

InformationIconQuestion.default = InformationIconQuestion;
